import { type FC, useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { setModalDisabled } from "../../../../redux/modals/actions";
import Input from "../../../input/input";

import * as CSS from "./correct-time.styles";

type CorrectTimeProps = {
	initialMatchTime: number;
	onChange: (newTime: number) => void;
};

const isValidMatchTime = (value: number) =>
	Number.isFinite(value) && value > 0 && value < 150;

const CorrectTime: FC<CorrectTimeProps> = ({ initialMatchTime, onChange }) => {
	const dispatch = useDispatch();
	// Owns the input's live value locally — the modal's `children` element is
	// created once (at dispatch time) and frozen in redux state, so a value
	// passed in as a controlled prop from outside never reflects further
	// keystrokes. setModalDisabled patches just the Confirm button's disabled
	// flag without needing the whole modal (and this element) recreated.
	const [value, setValue] = useState(initialMatchTime);

	const handleInputChange = useCallback(
		(next: number) => {
			setValue(next);
			onChange(next);
			dispatch(setModalDisabled(!isValidMatchTime(next)));
		},
		[onChange, dispatch],
	);

	return (
		<div style={{ width: "100%", marginTop: "1.4rem" }}>
			<CSS.InputLabel>Match time (minutes)</CSS.InputLabel>
			<Input
				value={value}
				type="number"
				onChange={(e) => handleInputChange(e.target.valueAsNumber)}
				id="input--correct-time"
			/>
		</div>
	);
};

export default CorrectTime;
